import { Icon } from '@chakra-ui/react';

export const FillCheckCircle = (props) => (
  <Icon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
      fill="#00CD69"
      fillOpacity="0.08"
    />
    <path
      d="M5.44397 9.33903L7.61097 11.506L7.59697 11.492L12.486 6.60303"
      stroke="#00CD69"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
